import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { ChipCloseEvent } from './chip-close-event';

/* eslint-disable */
/**
 * Chip component.
 * Sizes and styles controlled by BEM modifiers.
 *
 * @export
 * @class ChipComponent
 * @implements {OnInit}
 */
@Component({
    selector: '[ihdChip]',
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-chip',
        role: 'button',
        '[attr.type]': 'type',
    },
})
export class ChipComponent {
    @Input() type: string = 'button';
    @Input() id?: string | number;

    @Output('close') onClose: EventEmitter<ChipCloseEvent> = new EventEmitter();

    constructor() {}

    close(event: Event) {
        if (event) {
            event.stopPropagation();
        }

        this.onClose.emit(new ChipCloseEvent(this));
    }
}
